import { render, staticRenderFns } from "./KpiNumberOfRequestsTaken.vue?vue&type=template&id=6883adfd&"
import script from "./KpiNumberOfRequestsTaken.vue?vue&type=script&lang=js&"
export * from "./KpiNumberOfRequestsTaken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports